{
  "newTitle": "New Lesson",
  "editTitle": "Edit Lesson",
  "uploadingTitle": "Uploading Video",
  "uploadedTitle": "Video Uploaded",
  "saveLabel": "Save lesson",
  "savingLabel": "Saving",
  "titleLabel": "Title",
  "titlePlaceholder": "Lesson Title",
  "descriptionLabel": "Description",
  "descriptionPlaceholder": "A one-line summary of this lesson",
  "videoLabel": "Video",
  "textLabel": "Text",
  "fallbackFileName": "Video",
  "previewFailed": "Unable to get a playable URL for this video.",
  "uploadStartFailed": "The video upload could not be started.",
  "uploadFailed": "The video upload failed.",
  "thumbnailTargetFailed": "Unable to create an upload target for the thumbnail.",
  "thumbnailUploadFailed": "The thumbnail upload failed. Please try again.",
  "saveFailed": "Unable to save this Lesson right now.",
  "uploadSavedCaption": "The Lesson was saved. You can retry the upload, or close and add the video later.",
  "retryUpload": "Retry Upload",
  "close": "Close",
  "uploadComplete": "Upload Complete. Video will be available once processing completes",
  "uploading": "Uploading... {{percent}}%",
  "keepCurrentVideo": "Keep current video",
  "keepCurrentImage": "Keep current image",
  "clear": "Clear",
  "uploadsAfterCreate": "Uploads after the Lesson is created.",
  "preparingPreview": "Preparing preview…",
  "previewVideo": "Preview video",
  "noVideo": "No video on this lesson.",
  "thumbnailTitle": "Thumbnail",
  "thumbnailCaption": "Shown in the lesson list before the video plays.",
  "videoProcessing": "Processing",
  "videoUploaded": "Uploaded",
  "videoHosted": "Hosted",
  "videoUploadFailed": "Upload failed",
  "videoProcessingDetail": "Video processing.",
  "editor": {
    "contentArea": {
      "editableMarkdown": "editable markdown"
    },
    "toolbar": {
      "undo": "Undo {{shortcut}}",
      "redo": "Redo {{shortcut}}",
      "bold": "Bold",
      "removeBold": "Remove bold",
      "italic": "Italic",
      "removeItalic": "Remove italic",
      "blockTypeSelect": {
        "placeholder": "Block type",
        "selectBlockTypeTooltip": "Select block type"
      },
      "blockTypes": {
        "paragraph": "Paragraph",
        "heading": "Heading {{level}}",
        "quote": "Quote"
      },
      "bulletedList": "Bulleted list",
      "numberedList": "Numbered list",
      "link": "Create link",
      "table": "Insert Table",
      "toggleGroup": "toggle group"
    },
    "createLink": {
      "url": "URL",
      "urlPlaceholder": "Select or paste a URL",
      "text": "Anchor text",
      "textTooltip": "The text to be displayed for the link",
      "title": "Link title",
      "titleTooltip": "The link's title attribute, shown on hover",
      "saveTooltip": "Set URL",
      "cancelTooltip": "Cancel change"
    },
    "linkPreview": {
      "edit": "Edit link URL",
      "copyToClipboard": "Copy to clipboard",
      "copied": "Copied!",
      "remove": "Remove link"
    },
    "dialogControls": {
      "save": "Save",
      "cancel": "Cancel"
    },
    "table": {
      "columnMenu": "Column menu",
      "rowMenu": "Row menu",
      "textAlignment": "Text alignment",
      "alignLeft": "Align left",
      "alignCenter": "Align center",
      "alignRight": "Align right",
      "insertColumnLeft": "Insert a column to the left of this one",
      "insertColumnRight": "Insert a column to the right of this one",
      "deleteColumn": "Delete this column",
      "insertRowAbove": "Insert a row above this one",
      "insertRowBelow": "Insert a row below this one",
      "deleteRow": "Delete this row",
      "deleteTable": "Delete table"
    }
  }
}
